import { GetApiClient } from "@/utils/api-client";
import { DataSchema } from "common";

type GetModelsResponse = DataSchema.ModelList;

export const getModelsApi = (apiClient: GetApiClient) => {
  return apiClient.get<GetModelsResponse>("/api/models");
};
